// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const InsysAgreementsAPI = {
    //Read a weave quote from salesforce
    ReadQuoteByUID(fn, req) {
        try {
            fm.validateUrlParam(req["uid"], "uid");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/agreements/v1/quote/${req["uid"]}?${fm.renderURLSearchParams(req, ["uid"])}`, { method: "GET" });
    },
    // accept a weave quote
    AcceptQuote(fn, req) {
        try {
            fm.validateUrlParam(req["uid"], "uid");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/agreements/v1/quote/${req["uid"]}/accept`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // Accept a weave quote and create customer in 2cp
    SignQuote(fn, req) {
        try {
            fm.validateUrlParam(req["uid"], "uid");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/agreements/v1/quote/${req["uid"]}/sign`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    //Create an agreement
    Create(fn, req) {
        return fn(`/agreements/v1/agreements`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // Reject Quote Returns a rejected status for a given QuoteID
    RejectQuote(fn, req) {
        try {
            fm.validateUrlParam(req["quoteId"], "quoteId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/agreements/v1/quote/${req["quoteId"]}/reject`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    //  ReadCachedQuoteByUID returns the Quote details
    ReadCachedQuoteByUID(fn, req) {
        try {
            fm.validateUrlParam(req["uid"], "uid");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/agreements/v1/quote/${req["uid"]}/cache?${fm.renderURLSearchParams(req, ["uid"])}`, { method: "GET" });
    },
    // VerifyShippingAddress returns verfied address via smarty street API
    VerifyShippingAddress(fn, req) {
        return fn(`/agreements/v1/verify/shipping?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // SendLoA receive porting data id and sends most recent LoA for the porting data to customer for signing
    SendLOA(fn, req) {
        return fn(`/agreements/v1/sendloa`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ReadLOA Reads LOA date by ID
    ReadLOA(fn, req) {
        try {
            fm.validateUrlParam(req["loaId"], "loaId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/agreements/v1/loa/${req["loaId"]}?${fm.renderURLSearchParams(req, ["loaId"])}`, { method: "GET" });
    },
    // Sign LOA endpoint Handles and process the event when user signs an LoA
    SignLOA(fn, req) {
        return fn(`/agreements/v1/signloa`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetLOAStatus(fn, req) {
        return fn(`/agreements/v1/loa/status`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // generates and signs loa for internal ports
    GenerateInternalPortInLOA(fn, req) {
        return fn(`/agreements/v1/loa/portin/internal/generate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
